import { __awaiter, __generator } from "tslib";
import { VERSION } from './version';
var LIBPREFIX = 'amplitude-ts-unified';
export var libraryPlugin = function () {
    return {
        type: 'enrichment',
        name: '@amplitude/unified-library-plugin',
        execute: function (event) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    event.library = "".concat(LIBPREFIX, "/").concat(VERSION, "-").concat((_a = event.library) !== null && _a !== void 0 ? _a : '');
                    return [2 /*return*/, event];
                });
            });
        },
    };
};
//# sourceMappingURL=library.js.map